import { parseDate } from '@occc-app/lib/date';
import { TimeSeriesMetric } from '@occc/graphql';

import { HIGH_THRESHOLD, MEDIUM_THRESHOLD } from './my-stores.constants';

export const getMetrics = (history: TimeSeriesMetric[], numberOfStores: number) => {
  return history.map(({ date, value: disconnected }) => {
    const percentage = numberOfStores !== 0 ? (disconnected / numberOfStores) * 100 : 0;
    let high = 0;
    let medium = 0;
    let low = 0;

    if (percentage >= HIGH_THRESHOLD) {
      high = disconnected;
    } else if (percentage >= MEDIUM_THRESHOLD) {
      medium = disconnected;
    } else {
      low = disconnected;
    }

    return { date: parseDate(date), value: { high, medium, low } };
  });
};
